<template>
    <div>
        <div class="display-all" v-if="display_all">
            <div class="alert alert-success pt-3">
                <h3 class="text-center"  v-html="$t('intern_qpay_success.erfolg_titel')"></h3>
                <div class="text-center" v-html="$t('intern_qpay_success.erfolg_text')"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '../../EventBus';
    export default {
        name: 'payment-failure',
        data() {
            return {
                display_all: true,
            }
        },
        created() {
            this.$cookies.remove('currentBooking');
        },
        mounted() {
            window.parent.postMessage('SCROLL_TO_TOP');  
        },
    }
</script>

<style scoped>
.display-all{
    background-color: white;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
}
</style>